import { DurationFormatter } from "@amcharts/amcharts4/core";
import { TTypedTFunction } from "@lib/useTypedTranslation";
import moment from "moment";

export enum ChartTimePeriod {
  last30Days = 'last30Days',
  last7Days = 'last7Days',
  last48Hours = 'last48Hours'
}

export function isTimePeriod30Days(chartTimePeriod: ChartTimePeriod): boolean {
  return chartTimePeriod === ChartTimePeriod.last30Days;
}

export const formatDurationData = (t: TTypedTFunction, minuteBoundary?: boolean) => (data: number) => {
  const usageHours = Math.floor(data / 60 / 60);
  const usageMinutes = (data / 60) % 60;

  if (minuteBoundary && usageHours === 0 && usageMinutes < 1 && usageMinutes > 0) {
    return t('LESS_THAN_ONE_MINUTE', { ns: 'performance' });
  }

  const hoursText = t('HOUR', { count: usageHours, ns: 'timeState' });
  const minutesText = t('MINUTE', { count: usageMinutes, ns: 'timeState' });
  return new DurationFormatter().format(data, usageHours > 0 ? `h '${hoursText}' m '${minutesText}'` : `m '${minutesText}'`);
};

export const formatTooltipDate = (chartTimePeriod: ChartTimePeriod) => (date: number) => {
  return isTimePeriod30Days(chartTimePeriod) ?
    moment.utc(date).format('ll')
    :
    moment.utc(date).format('LLLL LT');
};
